module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "slot"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.select_time_slot_number')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "slot-options",
    attrs: {
      "id": "slot",
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "placeholder": "",
      "options": _vm.slotOptions,
      "allow-empty": false
    },
    model: {
      value: (_vm.slots),
      callback: function($$v) {
        _vm.slots = $$v
      },
      expression: "slots"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "slotHelpInline"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.schedules.time_slot_e_g')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a23df68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkingTimeSlot.vue
// module id = 1016
// module chunks = 1